export default "__VITE_ASSET__DjaS3ntB__"